<template>
    <a-layout class="container">
        <!-- 左侧区域 -->
        <hina-base-slider :currentMenuKey="curMenuKey" :currentOpenKey="curOpenKey" />
        <!-- 主体区域 -->
        <a-layout>
            <!-- 头部 -->
            <hina-user-info :user="objUserInfo" />

            <a-layout-content>
                <!-- 位置 -->
                <hina-bread-crumb :link="arrBreadLink" />

                <div class="wrapper">
                    <div class="wrap">
                        <div class="hd">
                            <div class="filter">
                                <div class="title">会员汇总</div>
                                <div class="query">
                                    <div class="query-item">
                                        <a-dropdown-button>
                                            查询方式
                                            <a-menu slot="overlay" @click="handleMenuClick" style="line-height: 48px">
                                                <a-menu-item key="1">
                                                    <a-space v-if="strQueryType == '姓名'" style="color: #45a3ff">按姓名查询</a-space>
                                                    <a-space v-else>按姓名查询</a-space>
                                                </a-menu-item>
                                            </a-menu>
                                            <a-icon slot="icon" type="user" />
                                        </a-dropdown-button>
                                    </div>
                                    <div class="query-item">
                                        <a-input v-model="queryParams" @keyup.enter="loadStaffList" type="text" />
                                    </div>
                                    <div class="query-item">
                                        <a-button @click="loadStaffList" type="primary">查询</a-button>
                                        <div class="query-item">
                                            <a-button type="primary" @click="handlerInviteModel">邀请</a-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="trans-table">
                            <a-table :columns="columns" :data-source="data" :pagination="pagination" :loading="loading" @change="handleTableChange">
                                <template slot="sourceSlot" slot-scope="text, record">
                                    <span v-if="text == 1">健康神器</span>
                                    <span v-if="text == 2">实体卡</span>
                                    <span v-if="text == 3">企业邀请</span>
                                    <span v-if="text == 4">渠道码</span>
                                </template>
                            </a-table>
                        </div>
                    </div>
                </div>
            </a-layout-content>
            <!-- 邀请弹框 -->
            <a-modal v-model="inviteModal" :width="500" :centered="true" :okButtonProps="{ style: { display: 'none' } }" cancelText="取消">
                <template v-slot:title>
                    <span>邀请扫码加入</span>
                    <span style="color: red">（ 请使用微信扫码 ）</span>
                </template>
                <div class="frm-staff">
                    <a-row class="frm-line" :gutter="10">
                        <vue-qr :logoSrc="qrCode.logoSrc" :text="qrCodeText" :callback="qrCodeCallback" :size="260" :correctLevel="1" :margin="10"></vue-qr>
                        <div style="margin-top: 20rpx;">
                            总邀请次数<span style="color: red;">{{ totalInviteCount }}</span
                            >次
                        </div>
                        <div style="margin-top: 20rpx;">
                            现有邀请人数<span style="color: red;">{{ currentInviteCount }}</span
                            >人
                        </div>
                    </a-row>
                </div>
                <!-- 企业编码： -->
                <div style="margin-top: 20rpx; text-align: center;">
                    企业编码：<span>{{ crtEnterpriseCode }}</span
                    >
                </div>
            </a-modal>
        </a-layout>
    </a-layout>
</template>

<script>
import HinaBaseSlider from 'components/HinaBaseSlider/HinaBaseSlider'
import HinaUserInfo from 'components/HinaUserInfo/HinaUserInfo'
import HinaBreadCrumb from 'components/HinaBreadCrumb/HinaBreadCrumb'
import utils from 'assets/js/util'
import vueQr from 'vue-qr'
import locale from 'ant-design-vue/lib/date-picker/locale/zh_CN'

const columns = [
    {
        title: '手机号',
        dataIndex: 'phone'
    },
    {
        title: '用户名称',
        dataIndex: 'name'
    },
    {
        title: '来源',
        dataIndex: 'source',
        scopedSlots: { customRender: 'sourceSlot' }
    },
    {
        title: '客户池人数',
        dataIndex: 'inviterCount'
    },
    {
        title: '累计收益',
        dataIndex: 'money'
    },
    {
        title: '邀请人',
        dataIndex: 'inviterName'
    },
    {
        title: '邀请时间',
        dataIndex: 'inviterTime'
    },
    {
        title: '订单价格(元)',
        dataIndex: 'practicalPrice'
    },
]

export default {
    name: 'Profile',
    components: {
        HinaBaseSlider,
        HinaUserInfo,
        HinaBreadCrumb,
        vueQr
    },
    data() {
        return {
            locale,
            objUserInfo: {},
            curMenuKey: ['firstStaff'],
            curOpenKey: ['sub4'],
            arrBreadLink: [],
            color: 'error',
            pagination: {},
            loading: false,
            strQueryType: '姓名',
            queryParams: '',
            data: [],
            columns,
            pagination: {
                pageSize: 10,
                total: 0,
                current: 1
            },
            inviteModal: false, // 邀请弹框
            qrCode: {
                logoSrc: 'http://fxinpz.com/images/fxpeizhen/system/202210/fc4297f3c53b43fca2575ecc9fb4b6a8.jpg' // 嵌入二维码中心的logo图片地址。
            },
            qrCodeUrl: '', // 存放生成的二维码url
            totalInviteCount: 0,
            currentInviteCount: 0,
            crtEnterpriseCode:'', //企业编码
        }
    },
    computed: {
        qrCodeText() {
            return `https://fxinpz.com/wechat/openvip?enterpriseId=${this.objUserInfo.id}&isInvite=true&inviterAdCode=${this.objUserInfo.adCode}`
            // return `https://fxinpz.com/wechat/openvip?enterpriseId=1656567583526309890`
            // return `https://fxinpz.com/wechat/joinEnterprise?enterpriseId=1656567583526309890&enterpriseName=北京天天科技有限公司`; // 二维码的内容，即扫出来的结果。
        }
    },
    methods: {
        qrCodeCallback(url) {
            this.qrCodeUrl = url
        },
        // 获取通过邀请进入企业人员数量
        loadJoinUserCount() {
            this.$get('/enterpriseUser/getInviteUserCount', {}).then((res) => {
                if (res.success) {
                    this.totalInviteCount = res.result.totalInviteCount
                    this.currentInviteCount = res.result.currentInviteCount
                }
            })
        },
        // 邀请弹框
        handlerInviteModel() {
            this.inviteModal = true
            this.loadJoinUserCount()
        },
        //查询职员列表
        loadStaffList() {
            //查询对象
            let params = {
                name: null,
                pageNumber: this.pagination.current,
                pageSize: this.pagination.pageSize,
                type: 2
            }
            params.name = this.queryParams
            this.data = []
            this.$get('enterpriseUser/getInviteUserAll', params).then((res) => {
                let records = res.result.records
                for (let i = 0; i < records.length; i++) {
                    this.data.push({
                        key: i,
                        id: records[i].id,
                        phone: records[i].phone,
                        name: records[i].name,
                        inviterCount: records[i].inviterCount,
                        money: records[i].money,
                        inviterName: records[i].inviterName,
                        inviterTime: records[i].inviterTime,
                        inviterCount: records[i].inviterCount,
                        practicalPrice: records[i].practicalPrice,
                        source: records[i].source,
                        userId: records[i].userId
                    })
                }
                this.pagination = {
                    current: res.result.current,
                    pageSize: res.result.size,
                    total: res.result.total
                }
                this.loading = false
            })
        },

        handleMenuClick: function(e) {
            this.strQueryType = '姓名'
        },

        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.loading = true
            this.loadStaffList()
        }
    },
    mounted: function() {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.objUserInfo = {
            id: userInfo.id,
            name: userInfo.enterpriseFullName,
            adCode: userInfo.adCode
        }
        if (userInfo.enterpriseCode) {
            this.crtEnterpriseCode = userInfo.enterpriseCode
        }
        this.arrBreadLink.push({ name: '会员汇总', link: '/firstStaff' })
        this.loadStaffList()
    }
}
</script>

<style lang="scss" scoped>
.wrapper {
    .wrap {
        margin: 20px 0 0;
        padding: 0 24px;
        background: #fff;
        min-height: 240px;

        .hd {
            height: 72px;
            line-height: 72px;
            color: #333;
            font-weight: 600;
            font-size: 18px;
            position: relative;
            margin-bottom: 30px;

            &::after {
                position: absolute;
                content: '';
                height: 1px;
                background: rgba(0, 0, 0, 0.1);
                left: 0;
                right: 0;
                bottom: 0;
            }

            .filter {
                display: flex;
                justify-content: space-between;
                align-items: center;

                .query {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .query-item {
                        padding: 0 0 0 5px;
                        height: 48px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }
        }

        .trans-table {
            padding: 0 0 5px;
        }
    }

    .wrap:first-of-type {
        margin: 0;
    }
}

.frm-staff {
    padding: 20px 50px;
    text-align: center;

    .frm-line {
        min-height: 72px;
        padding: 12px 0;
        box-sizing: border-box;

        .lab {
            font-size: 16px;
            line-height: 48px;
            text-align: right;
            position: relative;

            &::after {
                position: relative;
                content: '：';
            }
        }

        .required {
            &::before {
                position: relative;
                content: '*';
                color: red;
                padding: 0 5px 0 0;
            }
        }

        .txt {
            line-height: 48px;
            font-size: 16px;
        }
    }
}
</style>
